// extracted by mini-css-extract-plugin
module.exports = {"inlineAd":"jT","innerWrapper":"kT","tooltipWrapper":"lT","tooltip":"mT","content":"nT"};